module.exports = __webpack_public_path__ + "media/images/mobile/solutions/bg22-aa6a6ad18ed5493a21dc23276be5345a.png";